import VMask from 'v-mask'
import Vue from 'vue'
import VueMoment from 'vue-moment'
import App from './App.vue'
import banks from './banks.json'
import DashboardPlugin from './plugins/dashboard-plugin'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueMoment)
Vue.use(VMask)
Vue.use(DashboardPlugin)

Vue.filter('format', (val, decimals = 2) => {
	if (typeof val === 'undefined') {
		val = 0
	}

	return val.toLocaleString(undefined, {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	})
})
Vue.filter('bankName', (code) => {
	if (code === 'TRUEWALLET') {
		return 'ทรูมันนี่วอลเล็ท'
	} else if (code === 'WHEEL') {
		return 'กงล้อเสี่ยงโชค'
	} else if (code === 'CASHBACK') {
		return 'แคชแบ็ก'
	} else if (code === 'BONUS') {
		return 'โบนัส'
	} else if (code === 'AFFILIATE') {
		return 'แนะนำเพื่อน'
	}
	return banks[code] ? banks[code] : code
})
Vue.filter('providerName', (code) => {
	if (code === 'api') {
		return 'API'
	} else if (code === 'easynet') {
		return 'EasyNet'
	} else if (code === 'sms') {
		return 'SMS'
	} else if (code == 'slip') {
		return 'Slip'
	}
	return code
})
Vue.filter('upperCase', (txt) => txt.toUpperCase())
Vue.filter('ucFirst', (txt) => txt.charAt(0).toUpperCase() + txt.slice(1))

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
